import React, { Component } from "react";

import SearchBar from "../../../views/components/SearchBar.Component";
import SearchResult from "../../src/models/SearchResult";
import Translations from "../../src/models/Translations";
import SearchService from "../../src/services/search.service";
import SearchResultDescription from "../views/SearchResultDescription";
import FAQArticleView from "../../../faq/src/views/components/FAQArticleView";
import Paging from "../../../views/components/Paging.Component";

type SearchPageProps = {
  service: SearchService;
  itemsPerPage: number;
  startPage: number;
  translations: Translations;
  language: string;
  pageTitle: string;
  persona: string;
  initialKeywords: string;
  summaryLength: number;
};

type SearchPageState = {
  keywords: string;
  result: SearchResult;
  amountOfResults: number;
  currentPage: number;
  searched: boolean;
};

export default class SearchPage extends Component<SearchPageProps, SearchPageState> {
  constructor(props: SearchPageProps) {
    super(props);
    this.state = {
      keywords: props.initialKeywords,
      result: new SearchResult(),
      amountOfResults: 0,
      currentPage: this.props.startPage,
      searched: props.initialKeywords.length > 0
    };

  }

  componentDidMount(): void {
    if (this.props.initialKeywords !== "") {
      this.search(this.props.initialKeywords, this.props.startPage);
    }
  }

  public async search(keyword: string, page = this.props.startPage) {
    if (keyword.length > 0) {
      const result: SearchResult = await this.props.service.searchContent(
        keyword,
        this.props.language,
        this.props.persona,
        this.props.itemsPerPage,
        page,
        this.props.summaryLength
      );

      this.setState({
        result: result,
        keywords: keyword,
        amountOfResults: result.page == 1 ? result.totalNumberOfSearchResults : this.state.amountOfResults,
        currentPage: page,
        searched: true
      });
    } else {
      this.setState({
        searched: false
      });
    }
  }

  public render() {
    return (
      <React.Fragment>
        <h1>{this.props.pageTitle}</h1>
        <SearchBar
          initialKeyword={this.props.initialKeywords}
          onSearch={(keyword: string) => {
            this.search(keyword);
          }}
          searchButtonText={this.props.translations.searchButtonText}
          placeholderText={this.props.translations.searchPlaceholder}
        />

        {(this.state.searched && (this.state.result.searchResults || this.state.result.faqs)) && (
          <SearchResultDescription
            count={this.state.amountOfResults}
            translations={this.props.translations}
            keywords={this.state.keywords}
          />
        )}

        {this.state.searched && this.state.result.faqs && (
          <div className="mb-5">
            {this.state.result.faqs.map((faq, index) => {
              return <FAQArticleView article={faq} key={"article_" + index} id={"article_" + index} />;
            })}
          </div>
        )}

        {this.state.searched && this.state.result.searchResults &&
          this.state.result.searchResults.map((searchResult, key) => {
            return (
              <React.Fragment key={"searchResult-" + key}>
                {searchResult.type != "" && <p className="mb-2 text-brown-100 text-overline small">{searchResult.type}</p>}
                <a
                  href={searchResult.url}
                  title={searchResult.title}
                  className="font-weight-bold"
                  dangerouslySetInnerHTML={{ __html: searchResult.title }}></a>
                <p className="text-brown" dangerouslySetInnerHTML={{ __html: searchResult.content }}></p>
              </React.Fragment>
            );
          })}

        {this.state.searched &&
          <Paging
            onPageChange={(page: number) => {
              this.search(this.state.keywords, page);
            }}
            currentPage={this.state.currentPage}
            itemsPerPage={this.props.itemsPerPage}
            totalNumberOfItems={this.state.amountOfResults}
            textOf={this.props.translations.page.of}
            textPrevious={this.props.translations.page.previous}
            textNext={this.props.translations.page.next}
          />
        }
      </React.Fragment>
    );
  }
}
